/* istanbul ignore file */
import AbacusExperiments from '../../utils/AbacusExperiments';
import React from 'react';

const experimentDefaults = {};
experimentDefaults[AbacusExperiments.HA_VT_EG_MEDIA_GATEWAY_THROTTLE] = 0;
experimentDefaults[AbacusExperiments.VRBO_VT_DIRECT_NAV_ONLY] = 0;

export default React.createContext(experimentDefaults);
